import {ApexOptions} from "apexcharts";
import dynamic from "next/dynamic";
import {useEffect, useState} from "react";
const Chart = dynamic(() => import("react-apexcharts"), {ssr: false});

interface ChartSeries {
  name: string;
  data: number[];
}
type trends = {
  acceleration: number;
  date: number;
  harshBraking: number;
  overSpeed: number;
}[];
export default function NokiaSafetyRiskChart({
  chartValues
}: {
  chartValues: trends;
}) {
  const [safetyRiskChartOption, setSafetyRiskChartOption] = useState<{
    options: ApexOptions;
    series: ChartSeries[];
  }>({
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
        toolbar: {
          show: false
        },

        zoom: {
          enabled: true
        }
      },
      colors: ["#FDD835", "#FB8C00", "#FC2A3D"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0
            }
          }
        }
      ],
      dataLabels: {
        enabled: false
      },
      plotOptions: {
        bar: {
          columnWidth: "30%",
          barHeight: "70%",
          horizontal: false,
          borderRadius: 5
        }
      },
      yaxis: {
        // min: 0,
        // max: 3000,
        tickAmount: 5,
        title: {
          text: "Breach Count",
          style: {
            fontWeight: 700,
            fontSize: "12px",
            fontFamily: "Inter, sans-serif"
          }
        }
      },
      xaxis: {
        categories: []
      },

      legend: {
        show: true,
        position: "top",
        horizontalAlign: "right",
        customLegendItems: [
          "Sudden Acceleration",
          "Harsh Braking",
          "Over speeding"
        ],
        markers: {
          fillColors: ["#FDD835", "#FB8C00", "#FC2A3D"],
          shape: "line",
          size: 10,
          strokeWidth: 3
        },
        labels: {
          colors: "#808080"
        }
      },
      fill: {
        opacity: 1
      }
    },
    series: [
      {
        name: "Sudden Acceleration",
        data: []
      },
      {
        name: "Harsh Breaking",
        data: []
      },
      {
        name: "Over Speeding",
        data: []
      }
    ]
  });
  useEffect(() => {
    let acc: any = [];
    let harshb: any = [];
    let ospeed: any = [];
    let dateLabel: any = [];
    if (chartValues.length > 0) {
      acc = chartValues.map(ele => ele.acceleration);
      harshb = chartValues.map(ele => ele.harshBraking);
      ospeed = chartValues.map(ele => ele.overSpeed);
    }

    if (chartValues.length > 0) {
      dateLabel = chartValues.map(val => {
        const d = new Date(val.date);
        return d.toLocaleDateString("en-IN", {day: "numeric", month: "short"});
      });
    }

    //

    setSafetyRiskChartOption(prev => ({
      ...prev,
      options: {
        ...prev.options,
        xaxis: {
          ...prev.options.xaxis,
          categories: dateLabel
        }
      },
      series: [
        {
          name: "Sudden Acceleration",
          data: acc
        },
        {
          name: "Harsh Breaking",
          data: harshb
        },
        {
          name: "Over Speeding",
          data: ospeed
        }
      ]
    }));
  }, [chartValues]);
  return (
    <div>
      <div>
        <Chart
          options={safetyRiskChartOption.options}
          series={safetyRiskChartOption.series}
          type="bar"
          height={180}
        />
      </div>
    </div>
  );
}
